import { render, staticRenderFns } from "./WImage.vue?vue&type=template&id=26788882&"
import script from "./WImage.vue?vue&type=script&lang=js&"
export * from "./WImage.vue?vue&type=script&lang=js&"
import style0 from "./WImage.vue?vue&type=style&index=0&id=26788882&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports